<div class="h-full w-72 dispatch-card-selector">
    <ng-select class="w-full border-transparent attributeSelector" 
        [items]="attributeList" bindLabel="label" bindValue="key" [clearable]="false"
        [multiple]="false" groupBy="group_name" [(ngModel)]='selectedValue'
        placeholder="{{'text.search_fields' | translate}}" (change)="onOptionSelected($event)" [isOpen]="true"
       >
    </ng-select>
</div>